import { noteForIndex, triggerMomentary, type InstrumentPlayerProps } from "../playerTypes";

export function KoraPlayer(props: InstrumentPlayerProps) {
  return (
    <div className="instrument-ui kora-ui" data-testid="instrument-player-kora">
      <div className="kora-frame" aria-label="21 string kora harp-lute" data-control-target="kora-ranks">
        <div className="kora-row left-row" aria-label="Left string row">
          {Array.from({ length: 11 }, (_, index) => (
            <button key={index} type="button" className="kora-string" aria-label={`Left thumb kora string ${index + 1}`} onClick={() => triggerMomentary(props, noteForIndex(props.instrument.playableNotes, index), "left_thumb", 0.64, 480)} />
          ))}
        </div>
        <div className="kora-bridge" aria-hidden="true">bridge</div>
        <div className="kora-row right-row" aria-label="Right string row">
          {Array.from({ length: 10 }, (_, index) => (
            <button key={index} type="button" className="kora-string" aria-label={`Right index kora string ${index + 1}`} onClick={() => triggerMomentary(props, noteForIndex(props.instrument.playableNotes, index + 11), "right_index", 0.68, 480)} />
          ))}
        </div>
      </div>
      <div className="instrument-control-strip">
        <button type="button" aria-label="Trigger kora arpeggio scheduler" onClick={() => props.onControl("kora_arpeggio")}>Arpeggio gesture</button>
        <button type="button" aria-label="Trigger kora ostinato hold" data-control-target="kora-ostinato" onClick={() => props.onControl("kora_ostinato")}>Ostinato hold</button>
      </div>
      <p className="instrument-note">Jali/griot context is part of this instrument identity, not a decorative label.</p>
    </div>
  );
}
